import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useKpFilterStore = defineStore('kpfilters', () => {
  const kpStart = ref<number>(0)
  const kpEnd = ref<number>(100)

  const kpMinRange = ref<number>(0)
  const kpMaxRange = ref<number>(100)

  const isMinMaxSet = ref<boolean>(false)

  function setMinMaxRange(minRange: number, maxRange: number) {
    if (!isMinMaxSet.value) {
      kpMinRange.value = minRange
      kpMaxRange.value = maxRange

      kpStart.value = minRange
      kpEnd.value = maxRange

      isMinMaxSet.value = true
    }
  }

  const setkpStart = (newKpStart: number) => {
    if (newKpStart >= kpMinRange.value) {
      kpStart.value = newKpStart
    }
  }

  const setkpEnd = (newKpEnd: number) => {
    if (newKpEnd <= kpMaxRange.value) {
      kpEnd.value = newKpEnd
    }
  }

  const setkp = (newKp: number[]) => {
    if (newKp[0] >= kpMinRange.value) {
      kpStart.value = newKp[0]
    }

    if (newKp[1] <= kpMaxRange.value) {
      kpEnd.value = newKp[1]
    }
  }

  const resetMinMax = () => {
    isMinMaxSet.value = false
  }

  const reset = () => {
    kpStart.value = kpMinRange.value
    kpEnd.value = kpMaxRange.value
  }

  return {
    setkpStart,
    setkpEnd,
    setkp,
    setMinMaxRange,
    resetMinMax,
    reset,
    kpStart,
    kpEnd,
    kpMinRange,
    kpMaxRange
  }
})
